import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import StandardPagination from "../../components/pagination/StandardPagination.vue";
import ActionButtons from "../../components/actions/ActionButtons.vue";
import DotacaoConcatenada from "../../components/dotacaoConcatenada/DotacaoConcatenada.vue";
import { DotacaoService } from "../../services/DotacaoService";
import { ExercicioService } from "../../services/ExercicioService";
import { UnidadeExecutoraService } from "../../services/UnidadeExecutoraService";
import { UnidadeOrcamentariaService } from "../../services/UnidadeOrcamentariaService";
import { AcaoService } from "../../services/AcaoService";
import { ProgramaService } from "../../services/ProgramaService";
import { GrupoService } from "../../services/GrupoService";
import { ElementoService } from "../../services/ElementoService";
import { ElementoItemService } from "../../services/ElementoItemService";
import { IpgService } from "../../services/IpgService";
import { FonteService } from "../../services/FonteService";
import { IpuService } from "../../services/IpuService";
import moment from "moment";

export default {
    name: "GerenciarDotacoes",
    components: {
        Breadcrumb,
        StandardPagination,
        ActionButtons,
        DotacaoConcatenada
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Dotações',
                disabled: false
            },
            {
                text: 'Gerenciamento de Dotações Orçamentárias',
                disabled: true
            }
        ],
        headers: [
            { text: 'Exercício', align: 'center', value: 'exercicio.ano', width: '100px' },
            { text: 'Código da Dotação', align: 'center', value: 'dotacao', width: '800px' },
            { text: 'Valor da Dotação', align: 'center', value: 'valor', width: '140px' },
            { text: 'Status', align: 'center', value: 'ativo', width: '100px' },
        ],
        filters: {
            exercicioFilter: null,
            unidadeExecutoraFilter: null,
            unidadeOrcamentariaFilter: null,
            acaoFilter: null,
            programaFilter: null,
            grupoFilter: null,
            elementoFilter: null,
            elementoItemFilter: null,
            ipgFilter: null,
            fonteFilter: null,
            dotacaoAtivoFilter: false,
            dotacaoInativoFilter: false,
            dataInicio: null,
            dataFim: null,
        },
        items: [],
        itemSelected: [],
        modalEdit: false,
        modalCreate: false,
        exerciciosOptions: [],
        acaoOptions: [],
        ipuOptions: [],
        ipgOptions: [],
        grupoOptions: [],
        programaOptions: [],
        elementoOptions: [],
        elementoItemOptions: [],
        fonteOptions: [],
        unidadeExecutoraOptions: [],
        unidadeOrcamentariaOptions: [],
        page: 1,
        totalItems: 0,
        itemsPerPage: 10,
        itemsPerPageOptions: [10, 20, 50],
        showFilters: true
    }),
    computed: {
        computedHeaders() {
            return this.headers;
        },
        isAllSelected() {
            return this.items.length > 0 && this.itemSelected.length === this.items.length;
        },
        isIndeterminate() {
            return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
        }
    },
    created() {
        this.listarDotacoesPaginado();
        this.listarExerciciosSelect();
        this.listarAcoesSelect();
        this.listarIpusSelect();
        this.listarIpgsSelect();
        this.listarGruposSelect();
        this.listarProgramasSelect();
        this.listarElementosItensSelect();
        this.listarElementosSelect();
        this.listarFontesSelect();
        this.listarUnidadeExecutoraSelect();
        this.listarUnidadeOrcamentariaSelect()
    },
    watch: {
        page: async function(newValue) {
            this.page = newValue;
            await this.listarDotacoesPaginado();
        },
        'filters.exercicioFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarDotacoesPaginado();
            }
        },
        'filters.unidadeExecutoraFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarDotacoesPaginado();
            }
        },
        'filters.unidadeOrcamentariaFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarDotacoesPaginado();
            }
        },
        'filters.acaoFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarDotacoesPaginado();
            }
        },
        'filters.programaFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarDotacoesPaginado();
            }
        },
        'filters.grupoFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarDotacoesPaginado();
            }
        },
        'filters.elementoFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarDotacoesPaginado();
            }
        },
        'filters.elementoItemFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarDotacoesPaginado();
            }
        },
        'filters.ipgFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarDotacoesPaginado();
            }
        },
        'filters.fonteFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarDotacoesPaginado();
            }
        },
        'filters.ipuFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarDotacoesPaginado();
            }
        },
        'filters.dotacaoAtivoFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarDotacoesPaginado();
            }
        },
        'filters.dotacaoInativoFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarDotacoesPaginado();
            }
        },

        'filters.dataInicio': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarDotacoesPaginado();
            }
        },
        'filters.dataFim': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.listarDotacoesPaginado();
            }
        }
    },
    methods: {
        async listarDotacoesPaginado() {
            try {
                const filter = this.prepareFormFilter();

                const response = await DotacaoService.index(filter);

                if (typeof response !== 'string') {
                    this.items = response.data.data;
                    this.totalItems = response.data.total;
                    this.itemSelected = [];
                    this.$forceUpdate();
                } else {
                    console.error('Não foi possível obter os dotações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os dotações:', error);
            }
        },
        async listarExerciciosSelect() {
            try {
                const response = await ExercicioService.select();
                if (response) {
                    this.exerciciosOptions = response.data.map((el) => {
                        return {
                            text: el.ano,
                            value: el.ano,
                        };
                    });
                    this.exerciciosOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os dotações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os dotações:', error);
            }
        },
        async listarAcoesSelect() {
            try {
                const response = await AcaoService.select();

                if (response) {
                    this.acaoOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_acao} - ${el.descricao_acao}`,
                            value: el.id,
                        };
                    });
                    this.acaoOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os dotações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os dotações:', error);
            }
        },
        async listarIpusSelect() {
            try {
                const response = await IpuService.select();
                if (response) {
                    this.ipuOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_ipu} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.ipuOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os dotações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os dotações:', error);
            }
        },
        async listarIpgsSelect() {
            try {
                const response = await IpgService.select();
                if (response) {
                    this.ipgOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_ipg} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.ipgOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os dotações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os dotações:', error);
            }
        },
        async listarGruposSelect() {
            try {
                const response = await GrupoService.select();
                if (response) {
                    this.grupoOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_grupo} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.grupoOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os dotações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os dotações:', error);
            }
        },
        async listarProgramasSelect() {
            try {
                const response = await ProgramaService.select();
                if (response) {
                    this.programaOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_programa} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.programaOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os dotações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os dotações:', error);
            }
        },
        async listarUnidadeExecutoraSelect() {
            try {
                const response = await UnidadeExecutoraService.select();
                if (response) {
                    this.unidadeExecutoraOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_unidade} - ${el.nome}`,
                            value: el.id,
                        };
                    });
                    this.unidadeExecutoraOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os dotações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os dotações:', error);
            }
        },
        async listarUnidadeOrcamentariaSelect() {
            try {
                const response = await UnidadeOrcamentariaService.select();
                if (response) {
                    this.unidadeOrcamentariaOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_unidade} - ${el.nome}`,
                            value: el.id,
                        };
                    });
                    this.unidadeOrcamentariaOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os dotações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os dotações:', error);
            }
        },
        async listarElementosItensSelect() {
            try {
                const response = await ElementoItemService.select();
                if (response) {
                    this.elementoItemOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_elemento_item} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.elementoItemOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os dotações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os dotações:', error);
            }
        },
        async listarElementosSelect() {
            try {
                const response = await ElementoService.select();
                if (response) {
                    this.elementoOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_elemento} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.elementoOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os dotações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os dotações:', error);
            }
        },
        async listarFontesSelect() {
            try {
                const response = await FonteService.select();
                if (response) {
                    this.fonteOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_fonte} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.fonteOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os dotações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os dotações:', error);
            }
        },
        async destroyDotacoes() {
            try {
                const ids = this.itemSelected.map(dotacao => dotacao.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("dotacoes[]", id);
                });

                const response = await DotacaoService.destroy(formData);

                if (!response) {
                    console.error('Não foi possível excluir os dotações.');
                }

                this.listarDotacoesPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao excluir os dotações:', error);
            }
        },
        async activateDotacoes() {
            try {
                const ids = this.itemSelected.map(dotacao => dotacao.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("dotacoes[]", id);
                });

                const response = await DotacaoService.activate(formData);

                if (!response) {
                    console.error('Não foi possível ativar os dotações.');
                }

                this.listarDotacoesPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao ativar os dotações:', error);
            }
        },
        async deactivateDotacoes() {
            try {
                const ids = this.itemSelected.map(dotacao => dotacao.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("dotacoes[]", id);
                });

                const response = await DotacaoService.deactivate(formData);

                if (!response) {
                    console.error('Não foi possível desativar os dotações.');
                }

                this.listarDotacoesPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao desativar os dotações:', error);
            }
        },
        openModal(value) {
            if (value == 'create') {
                this.modalCreate = true;
            }
            if (value == 'edit') {
                this.modalEdit = true;
            }
        },
        closeActionsDialog() {
            this.modalCreate = false;
        },

        prepareFormFilter() {
            const filter = new FormData();

            filter.append("page", this.page);
            filter.append("items_per_page", this.itemsPerPage);

            this.filters.exercicioFilter
            ? filter.append(
                "exercicio",
                this.filters.exercicioFilter
            )
            : null;

            this.filters.unidadeExecutoraFilter
            ? filter.append(
                "unidade_executora_id",
                this.filters.unidadeExecutoraFilter
            )
            : null;

            this.filters.unidadeOrcamentariaFilter
                ? filter.append(
                    "unidade_orcamentaria_id",
                    this.filters.unidadeOrcamentariaFilter
                )
                : null;

            this.filters.acaoFilter
                ? filter.append(
                    "acao_id",
                    this.filters.acaoFilter
                )
                : null;   

            this.filters.programaFilter
                ? filter.append(
                    "programa_id",
                    this.filters.programaFilter
                )
                : null;    

            this.filters.grupoFilter
                ? filter.append(
                    "grupo_id",
                    this.filters.grupoFilter
                )
                : null;  

            this.filters.elementoFilter
                ? filter.append(
                    "elemento_id",
                    this.filters.elementoFilter
                )
                : null;      

            this.filters.elementoItemFilter
                ? filter.append(
                    "elemento_item_id",
                    this.filters.elementoItemFilter
                )
                : null;     
    

            this.filters.ipgFilter
                ? filter.append(
                    "ipg_id",
                    this.filters.ipgFilter
                )
                : null; 
                
            this.filters.fonteFilter
                ? filter.append(
                    "fonte_id",
                    this.filters.fonteFilter
                )
                : null;    

            this.filters.ipuFilter
                ? filter.append(
                    "ipu_id",
                    this.filters.ipuFilter
                )
                : null;      

            this.filters.dataInicio
                ? filter.append(
                    "data_ini",
                    moment(this.filters.dataInicio).format("YYYY-MM-DD")
                  )
                : null;
            this.filters.dataFim
                ? filter.append(
                    "data_fim",
                    moment(this.filters.dataFim).format("YYYY-MM-DD")
                  )
                : null;    

            this.filters.dotacaoAtivoFilter
                ? filter.append(
                    "ativo",
                    this.filters.dotacaoAtivoFilter
                )
                : null;

            this.filters.dotacaoInativoFilter
                ? filter.append(
                    "inativo",
                    this.filters.dotacaoInativoFilter
                )
                : null;

            return filter;
        },
        clearFilters() {
            Object.keys(this.filters).forEach(key => {
                this.filters[key] = null;
            });
            this.page = 1;
            this.listarDotacoesPaginado();
        },
        toggleFilters() {
            this.showFilters = !this.showFilters;
        },
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.itemSelected = [];
            } else {
                this.itemSelected = [...this.items];
            }
        },
        getRowClass() {
            return 'table-row';
        },
        truncateText(text, maxLength) {
            if (!text) return '-';
            if (text.length <= maxLength) return text;
            return text.substring(0, maxLength) + '...';
        },
        formatCurrency(value) {
            if (value == null || value === undefined) return 'R$ 0,00';
            const numValue = typeof value === 'string' ? parseFloat(value) : value;
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(numValue);
        },
        formatDate(date) {
            if (!date) return '-';
            return moment(date).format('DD/MM/YYYY');
        },
        handlePageChange(newPage) {
            this.page = newPage;
            this.listarDotacoesPaginado();
        },
        handleItemsPerPageChange(newItemsPerPage) {
            this.itemsPerPage = newItemsPerPage;
            this.page = 1;
            this.listarDotacoesPaginado();
        },
        exportarDotacoes() {
            this.$globalAlert('Funcionalidade de exportação será implementada em breve!');
        },
        handleVisualizarDotacao() {
            if (this.itemSelected.length === 1) {
                this.$router.push(`/dotacoes/visualizar/${this.itemSelected[0].id}`);
            }
        },
        handleImportar() {
            this.$router.push('/importar-dotacoes-orcamentarias');
        }
        
    }
};
